if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      this.performRecommendations();
    }

    performRecommendations() {
      const recommendations = this.querySelector(
        '[data-recommendations]'
      );
      if (!recommendations) return;
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const recommendationsHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-recommendations]')?.innerHTML;
          if (!recommendationsHTML) return;
          this.classList.remove('hidden');
          var cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
          if(cartDrawerItemsFull) {
            cartDrawerItemsFull.classList.remove('.cart-drawer-items__full');
          }
          recommendations.innerHTML = recommendationsHTML;
          this.initSlider();
          this.initAddToCartButtons();
        });
    }

    initSlider() {
      this.slider = new Swiper(this.querySelector('.swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 16,
      });
    }

    initAddToCartButtons() {
      this.querySelectorAll('.product-recommendations__add-to-cart').forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          this.addToCart(button);
        });
      });
    }

    async addToCart(button) {
      if (button.disabled) return;

      const variantId = button.dataset.variantId;
      if (!variantId) return;

      // Show loading state
      button.classList.add('loading');
      button.disabled = true;

      try {
        // Create FormData for the cart add request
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        
        // Add sections to render
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          formData.append('sections', 'cart-drawer,cart-counter');
          formData.append('sections_url', window.location.pathname);
        }

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.description || 'Failed to add to cart');
        }

        const responseData = await response.json();

        // Update cart sections
        if (cartDrawer && responseData.sections) {
          // Update cart drawer content
          if (responseData.sections['cart-drawer']) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(responseData.sections['cart-drawer'], 'text/html');
            const newCartDrawerBody = doc.querySelector('#CartDrawer-Body');
            const currentCartDrawerBody = document.querySelector('#CartDrawer-Body');
            
            if (newCartDrawerBody && currentCartDrawerBody) {
              currentCartDrawerBody.innerHTML = newCartDrawerBody.innerHTML;
            }
          }

          // Update cart counter
          if (responseData.sections['cart-counter']) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(responseData.sections['cart-counter'], 'text/html');
            const newCounter = doc.querySelector('#shopify-section-cart-counter');
            const currentCounter = document.querySelector('#shopify-section-cart-counter');
            
            if (newCounter && currentCounter) {
              currentCounter.innerHTML = newCounter.innerHTML;
            }
          }
        
          // Open the drawer
          /*cartDrawer.open(button);*/
          window.SLIDECART_UPDATE(window.SLIDECART_OPEN);
        } else if (cartDrawer) {
          // Fallback: just open the drawer
          cartDrawer.open(button);
        }

      } catch (error) {
        console.error('Error adding to cart:', error);
        alert(error.message || 'Sorry, there was an error adding this item to your cart. Please try again.');
      } finally {
        // Remove loading state
        button.classList.remove('loading');
        button.disabled = false;
      }
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
